function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message
  if (error && typeof error === 'object' && 'shortMessage' in error) {
    return String((error as { shortMessage?: string }).shortMessage)
  }
  return String(error)
}

/** Rechazo explícito del usuario en MetaMask / EIP-1193 (4001). No reintentar otros caminos. */
export function isWalletUserRejection(error: unknown): boolean {
  if (!error) return false

  if (typeof error === 'object' && error !== null) {
    const code = (error as { code?: unknown }).code
    if (code === 4001 || code === '4001' || code === 'ACTION_REJECTED') return true
  }

  const combined = errorMessage(error).toLowerCase()
  return (
    combined.includes('user rejected') ||
    combined.includes('user denied') ||
    combined.includes('rejected the request') ||
    combined.includes('request rejected') ||
    combined.includes('action_rejected') ||
    combined.includes('transaction rejected')
  )
}
